<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<div class="camera-container no-user-select">
  <video #videoElement autoplay playsinline></video>

  <canvas #canvasElement hidden></canvas>

  <div class="controls">
    <button (click)="switchCamera()"><i class="fas fa-sync-alt"></i> Switch</button>
    <button (click)="captureImage()"><i class="fas fa-camera"></i> Capture</button>
  </div>

  <div class="captured" *ngIf="capturedImage()">
    <!-- Close Button with Font Awesome Icon -->
    <button class="close-btn" (click)="capturedImage.set(null)">
      <i class="fas fa-times"></i>
    </button>

    <img [src]="capturedImage()" class="mb-2" alt="Captured Image" (click)="openLightbox()">
    <button class="btn btn-theme" (click)="uploadImage()">Upload</button>
  </div>


</div>

<div class=" lightbox" *ngIf="lightboxOpen" tabindex="0">
  <span class="lightbox-close" (click)="closeLightbox()">&times;</span>
  <img [src]="capturedImage()" class="lightbox-img" alt="Enlarged Image">
  <div class="row">
    <button class="col btn btn-theme mt-2 mx-3" (click)="uploadImage()">Upload</button>
    <button class="col btn btn-secondary mt-2" (click)="deleteImage()">Cancel</button>  
  </div>
</div>